/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LinkModelUpgradeBody,
  ListModelUpgradesParams,
  ModelUpgrade,
  ModelUpgradeInput,
  ModelUpgrades,
  SchemaValidationErrorResponse,
  StandardError,
  UnlinkModelUpgradeBody
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Upgrade
 */
export const createModelUpgrade = (
    modelUpgradeInput: MaybeRefOrGetter<ModelUpgradeInput>,
 signal?: AbortSignal
) => {
      modelUpgradeInput = toValue(modelUpgradeInput);

      return axiosClient<ModelUpgrade>(
      {url: `/model-upgrades`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelUpgradeInput, signal
    },
      );
    }




export const getCreateModelUpgradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelUpgrade>>, TError,{data: ModelUpgradeInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelUpgrade>>, TError,{data: ModelUpgradeInput}, TContext> => {

const mutationKey = ['createModelUpgrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelUpgrade>>, {data: ModelUpgradeInput}> = (props) => {
          const {data} = props ?? {};

          return  createModelUpgrade(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelUpgradeMutationResult = NonNullable<Awaited<ReturnType<typeof createModelUpgrade>>>
    export type CreateModelUpgradeMutationBody = ModelUpgradeInput
    export type CreateModelUpgradeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Create Model Upgrade
 */
export const useCreateModelUpgrade = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelUpgrade>>, TError,{data: ModelUpgradeInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelUpgrade>>,
        TError,
        {data: ModelUpgradeInput},
        TContext
      > => {
      return useMutation(getCreateModelUpgradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Upgrades list
 */
export const listModelUpgrades = (
    params?: MaybeRefOrGetter<ListModelUpgradesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelUpgrades>(
      {url: `/model-upgrades`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelUpgradesQueryKey = (params?: MaybeRefOrGetter<ListModelUpgradesParams>,) => {
    return [
    'model-upgrades', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelUpgradesQueryOptions = <TData = Awaited<ReturnType<typeof listModelUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelUpgradesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelUpgrades>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelUpgradesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelUpgrades>>> = ({ signal }) => listModelUpgrades(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelUpgrades>>, TError, TData>
}

export type ListModelUpgradesQueryResult = NonNullable<Awaited<ReturnType<typeof listModelUpgrades>>>
export type ListModelUpgradesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Upgrades list
 */

export function useListModelUpgrades<TData = Awaited<ReturnType<typeof listModelUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelUpgradesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelUpgrades>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelUpgradesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Upgrade
 */
export const destroyModelUpgrade = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-upgrades/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelUpgradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelUpgrade>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelUpgrade>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyModelUpgrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelUpgrade>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyModelUpgrade(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelUpgradeMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelUpgrade>>>

    export type DestroyModelUpgradeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy Model Upgrade
 */
export const useDestroyModelUpgrade = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelUpgrade>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelUpgrade>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyModelUpgradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Upgrade Detail
 */
export const modelUpgrade = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelUpgrade>(
      {url: `/model-upgrades/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelUpgradeQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-upgrades',id
    ] as const;
    }


export const getModelUpgradeQueryOptions = <TData = Awaited<ReturnType<typeof modelUpgrade>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelUpgrade>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelUpgradeQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelUpgrade>>> = ({ signal }) => modelUpgrade(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelUpgrade>>, TError, TData>
}

export type ModelUpgradeQueryResult = NonNullable<Awaited<ReturnType<typeof modelUpgrade>>>
export type ModelUpgradeQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Upgrade Detail
 */

export function useModelUpgrade<TData = Awaited<ReturnType<typeof modelUpgrade>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelUpgrade>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelUpgradeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Upgrade
 */
export const updateModelUpgrade = (
    id: MaybeRefOrGetter<string>,
    modelUpgradeInput: MaybeRefOrGetter<ModelUpgradeInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelUpgradeInput = toValue(modelUpgradeInput);

      return axiosClient<ModelUpgrade>(
      {url: `/model-upgrades/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelUpgradeInput, signal
    },
      );
    }




export const getUpdateModelUpgradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelUpgrade>>, TError,{id: string;data: ModelUpgradeInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelUpgrade>>, TError,{id: string;data: ModelUpgradeInput}, TContext> => {

const mutationKey = ['updateModelUpgrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelUpgrade>>, {id: string;data: ModelUpgradeInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelUpgrade(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelUpgradeMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelUpgrade>>>
    export type UpdateModelUpgradeMutationBody = ModelUpgradeInput
    export type UpdateModelUpgradeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update Model Upgrade
 */
export const useUpdateModelUpgrade = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelUpgrade>>, TError,{id: string;data: ModelUpgradeInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelUpgrade>>,
        TError,
        {id: string;data: ModelUpgradeInput},
        TContext
      > => {
      return useMutation(getUpdateModelUpgradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Link Model Upgrade to Model
 */
export const linkModelUpgrade = (
    id: MaybeRefOrGetter<string>,
    linkModelUpgradeBody: MaybeRefOrGetter<LinkModelUpgradeBody>,
 signal?: AbortSignal
) => {
      id = toValue(id);
linkModelUpgradeBody = toValue(linkModelUpgradeBody);

      return axiosClient<ModelUpgrade>(
      {url: `/model-upgrades/${id}/link`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: linkModelUpgradeBody, signal
    },
      );
    }




export const getLinkModelUpgradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkModelUpgrade>>, TError,{id: string;data: LinkModelUpgradeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof linkModelUpgrade>>, TError,{id: string;data: LinkModelUpgradeBody}, TContext> => {

const mutationKey = ['linkModelUpgrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkModelUpgrade>>, {id: string;data: LinkModelUpgradeBody}> = (props) => {
          const {id,data} = props ?? {};

          return  linkModelUpgrade(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkModelUpgradeMutationResult = NonNullable<Awaited<ReturnType<typeof linkModelUpgrade>>>
    export type LinkModelUpgradeMutationBody = LinkModelUpgradeBody
    export type LinkModelUpgradeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Link Model Upgrade to Model
 */
export const useLinkModelUpgrade = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkModelUpgrade>>, TError,{id: string;data: LinkModelUpgradeBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof linkModelUpgrade>>,
        TError,
        {id: string;data: LinkModelUpgradeBody},
        TContext
      > => {
      return useMutation(getLinkModelUpgradeMutationOptions(options), queryClient);
    }
    /**
 * @summary Unlink Model Upgrade from Model
 */
export const unlinkModelUpgrade = (
    id: MaybeRefOrGetter<string>,
    unlinkModelUpgradeBody: MaybeRefOrGetter<UnlinkModelUpgradeBody>,
 signal?: AbortSignal
) => {
      id = toValue(id);
unlinkModelUpgradeBody = toValue(unlinkModelUpgradeBody);

      return axiosClient<ModelUpgrade>(
      {url: `/model-upgrades/${id}/unlink`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: unlinkModelUpgradeBody, signal
    },
      );
    }




export const getUnlinkModelUpgradeMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkModelUpgrade>>, TError,{id: string;data: UnlinkModelUpgradeBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlinkModelUpgrade>>, TError,{id: string;data: UnlinkModelUpgradeBody}, TContext> => {

const mutationKey = ['unlinkModelUpgrade'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkModelUpgrade>>, {id: string;data: UnlinkModelUpgradeBody}> = (props) => {
          const {id,data} = props ?? {};

          return  unlinkModelUpgrade(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkModelUpgradeMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkModelUpgrade>>>
    export type UnlinkModelUpgradeMutationBody = UnlinkModelUpgradeBody
    export type UnlinkModelUpgradeMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Unlink Model Upgrade from Model
 */
export const useUnlinkModelUpgrade = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkModelUpgrade>>, TError,{id: string;data: UnlinkModelUpgradeBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unlinkModelUpgrade>>,
        TError,
        {id: string;data: UnlinkModelUpgradeBody},
        TContext
      > => {
      return useMutation(getUnlinkModelUpgradeMutationOptions(options), queryClient);
    }
